export const typo = {
  mb: "27px",
  mt: "69px",
};

export const grid = {
  alignItems: "center",
  mb: "88px",
};
export const gridItem = {
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
};

export const link = (theme) => ({
  backgroundColor: theme.palette.primary.lightGrey,
  width: "168px",
  height: "168px",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  borderRadius: "16px",
});

export const image = {
  maxWidth: "100%",
  cursor: "pointer",
};
